
  var _styles = {
  "free-card-main-container": {
    "width": "7.52rem",
    "height": "8.45333rem",
    "marginTop": "1.46667rem",
    "borderRadius": "0.48rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative"
  },
  "free-card-date": {
    "marginTop": "0.05333rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.48rem",
    "textAlign": "center"
  },
  "free-card-order-info": {
    "marginTop": "1.2rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.42667rem",
    "lineHeight": "0.50667rem",
    "textAlign": "center",
    "maxWidth": "6rem"
  },
  "free-card-tag": {
    "marginTop": "0.70667rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "borderRadius": "0.16rem",
    "height": "0.57333rem",
    "backgroundColor": "rgb(221,246,208)",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "width": "2.78667rem"
  },
  "free-card-tag-icon": {
    "width": "0.57333rem",
    "height": "0.57333rem",
    "backgroundColor": "rgb(91,168,87)",
    "borderRadius": "0.16rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "free-card-tag-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "textAlign": "center"
  },
  "free-card-tag-desc": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "textAlign": "center",
    "paddingLeft": "0.08rem"
  },
  "free-card-amount-container": {
    "marginTop": 0,
    "marginBottom": "-0.24rem",
    "marginLeft": "0.53333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "center"
  },
  "free-card-amount-symbol": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.8rem",
    "lineHeight": "1.06667rem"
  },
  "free-card-amount-value": {
    "color": "rgb(17,17,17)",
    "fontSize": "1.86667rem",
    "lineHeight": "2.4rem",
    "textAlign": "center"
  },
  "free-card-tip": {
    "marginTop": "-0.02667rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.45333rem",
    "textAlign": "center",
    "maxWidth": "6.66667rem"
  },
  "free-card-share-btn": {
    "marginTop": "0.62667rem",
    "width": "6.70667rem",
    "height": "1.2rem",
    "borderRadius": "7.45333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "relative"
  },
  "free-card-share-btn-text": {
    "color": "rgb(17,17,17)",
    "fontSize": "0.48rem",
    "lineHeight": "0.53333rem",
    "textAlign": "center",
    "fontWeight": "500"
  },
  "free-card-close-btn": {
    "marginTop": "0.8rem"
  }
};



  module.exports = _styles;
  